"use strict";

angular.module("core")
.component("btnAdd", {
    templateUrl: require("./btn-add.component.html"),
    bindings: {
        state: "@",
        disabled: "<?"
    },
    controller: function(Workflow) {
        this.add = function() {
            Workflow.startFromScratchAt(this.state);
        };
    },
    controllerAs: "btnAddCtrl"
});



//////////////////
// WEBPACK FOOTER
// ./core/btn-add/btn-add.component.js
// module id = 582
// module chunks = 0